"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeInAppMessaging = initializeInAppMessaging;
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const eventListeners_1 = require("../../../../eventListeners");
const helpers_1 = require("../utils/helpers");
const types_1 = require("../types");
const utils_2 = require("../utils");
const utils_3 = require("../../../utils");
const dispatchEvent_1 = require("./dispatchEvent");
/**
 * Initialize and set up in-app messaging category. This API needs to be called to enable other InAppMessaging APIs.
 *
 * @deprecated AWS will end support for Amazon Pinpoint on October 30, 2026.
 *
 * @remarks
 * Make sure to call this early in your app at the root entry point after configuring Amplify.
 * @example
 * ```ts
 * Amplify.configure(config);
 * initializeInAppMessaging();
 * ```
 */
function initializeInAppMessaging() {
    if ((0, utils_3.isInitialized)()) {
        return;
    }
    // register with the session listener
    utils_1.sessionListener.addStateChangeListener(utils_2.sessionStateChangeHandler, true);
    // wire up default Pinpoint message event handling
    (0, eventListeners_1.addEventListener)('messageDisplayed', (message) => {
        (0, helpers_1.recordAnalyticsEvent)(types_1.PinpointMessageEvent.MESSAGE_DISPLAYED, message);
        (0, utils_2.incrementMessageCounts)(message.id);
    });
    (0, eventListeners_1.addEventListener)('messageDismissed', (message) => {
        (0, helpers_1.recordAnalyticsEvent)(types_1.PinpointMessageEvent.MESSAGE_DISMISSED, message);
    });
    (0, eventListeners_1.addEventListener)('messageActionTaken', (message) => {
        (0, helpers_1.recordAnalyticsEvent)(types_1.PinpointMessageEvent.MESSAGE_ACTION_TAKEN, message);
    });
    // listen to analytics hub events
    core_1.Hub.listen('analytics', analyticsListener);
    (0, utils_3.initialize)();
}
function analyticsListener({ payload, }) {
    const { event, data } = payload;
    switch (event) {
        case 'record': {
            (0, dispatchEvent_1.dispatchEvent)(data);
            break;
        }
        default:
            break;
    }
}
